
import { defineComponent } from 'vue'
import OriginalPaper from '@/components/ja/publication/OriginalPaper.vue'
import ReviewPaper from '@/components/ja/publication/ReviewPaper.vue'
import BookList from '@/components/ja/publication/BookList.vue'
import ThesisList from '@/components/ja/publication/ThesisList.vue'

export default defineComponent({
  name: 'PublicationJa',
  components: {
    OriginalPaper,
    ReviewPaper,
    BookList,
    ThesisList
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'publication'
    }
  }
})
